import { communityThreads } from '@/mocks/homeData';

export default function CommunityBuzz() {
  return (
    <section id="buzz" className="w-full">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
            <i className="ri-chat-smile-2-line text-sm"></i>
            COMMUNITY
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            圈内讨论区
          </h2>
          <p className="mt-3 max-w-2xl font-label text-sm leading-relaxed text-foreground-600">
            有人负责贴证据，有人负责排时间线，也有人只是路过围观。讨论区里跟帖最活跃的几条，往往就是下一个热帖的起点。
          </p>
        </div>
        <span className="font-label text-sm text-foreground-500">
          今日跟帖 <span className="font-medium text-accent-600">1,286</span> 条
        </span>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {communityThreads.map((thread) => (
          <article
            key={thread.id}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <div className="flex items-center gap-3">
              <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full border border-background-200">
                <img
                  src={thread.avatar}
                  alt={`${thread.author} 的头像`}
                  title={`${thread.author} · 圈内讨论`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <div className="min-w-0">
                <p className="truncate font-label text-sm font-medium text-foreground-900">
                  {thread.author}
                </p>
                <p className="mt-0.5 flex items-center gap-1.5 font-label text-xs text-foreground-500">
                  <span className="rounded-full bg-accent-50 px-2 py-0.5 text-accent-700">
                    {thread.badge}
                  </span>
                  {thread.time}
                </p>
              </div>
            </div>

            <h3 className="mt-4 font-heading text-base font-bold leading-snug text-foreground-950">
              {thread.title}
            </h3>
            <p className="mt-2 flex-1 font-label text-sm leading-relaxed text-foreground-600">
              {thread.excerpt}
            </p>

            <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 font-label text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-chat-3-line text-sm"></i>
                {thread.replies} 条跟帖
              </span>
              <span className="flex items-center gap-1.5 text-primary-700">
                <i className="ri-share-forward-line text-sm"></i>
                围观全程
              </span>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <button
          type="button"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          <i className="ri-add-line text-base"></i>
          进入讨论区看更多跟帖
        </button>
      </div>
    </section>
  );
}